var _rect, _rect2, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgStartedRateAgentIcon = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#EBF6EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3004_1378",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3004_1378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 24.5C17.1 24.5 18.0417 24.1083 18.825 23.325C19.6083 22.5417 20 21.6 20 20.5C20 19.4 19.6083 18.4583 18.825 17.675C18.0417 16.8917 17.1 16.5 16 16.5C14.9 16.5 13.9583 16.8917 13.175 17.675C12.3917 18.4583 12 19.4 12 20.5C12 21.6 12.3917 22.5417 13.175 23.325C13.9583 24.1083 14.9 24.5 16 24.5ZM16 26.5C14.3333 26.5 12.9167 25.9167 11.75 24.75C10.5833 23.5833 10 22.1667 10 20.5C10 18.8333 10.5833 17.4167 11.75 16.25C12.9167 15.0833 14.3333 14.5 16 14.5C17.5 14.5 18.8042 14.975 19.9125 15.925C21.0208 16.875 21.6917 18.0667 21.925 19.5H30V21.5H21.925C21.6917 22.9333 21.0208 24.125 19.9125 25.075C18.8042 26.025 17.5 26.5 16 26.5Z",
    fill: "#008908"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStartedRateAgentIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/started-rate-agent-icon.134b6c82.svg";
export { ForwardRef as ReactComponent };